// extracted by mini-css-extract-plugin
export default {"card":"style_card__Z1dCY","container":"style_container__y4Dkq","loading":"style_loading__v+l3e"};